"use client";

import Image from "@/components/Image";
import Bottom from "@/app/components/Bottom";
import BottomH5 from "@/app/components/BottomH5";
import { useState, useEffect, useRef } from "react";
import Modal from "@/app/components/Modal";
// import { DeviceType, getDeviceTypeByUA } from "@/app/utils";

const Footer = () => {
  const [deviceType, setDeviceType] = useState<string>("other");

  const tabs = [
    {
      id: 1,
      name: "微信小程序",
      imageLeft: "mini_program_left_09.png",
      imageRight: "mini_program_right_09.png",
    },
    {
      id: 2,
      name: "个人版在线客服",
      imageLeft: "customer_left_09.png",
      imageRight: "customer_right_09.png",
    },
    {
      id: 3,
      name: "关注公众号",
      imageLeft: "official_account_09.png",
      imageRight: "official_account_right_09.png",
    },
  ];
  const [activeTab, setActiveTab] = useState(0);
  const autoSwitchRef = useRef<NodeJS.Timeout | null>(null);
  const [showVideo, setShowVideo] = useState<boolean>(false);

  // 在组件挂载时获取设备类型
  useEffect(() => {
    import("current-device").then((module) => {
      const deviceType = module.default.type;
      setDeviceType(deviceType);
      if (deviceType === "desktop") {
        setDeviceType("pc");
      }
      if (deviceType === "unknown") {
        setDeviceType("other");
      }
    });
  }, []);

  // 自动切换逻辑
  useEffect(() => {
    autoSwitchRef.current = setInterval(() => {
      setActiveTab((prev) => (prev + 1) % tabs.length);
    }, 2000);

    return () => {
      if (autoSwitchRef.current) {
        clearInterval(autoSwitchRef.current);
      }
    };
  }, [tabs.length]);

  // 鼠标悬停暂停切换
  const handleMouseEnter = (index: number) => {
    if (autoSwitchRef.current) {
      clearInterval(autoSwitchRef.current);
    }
    setActiveTab(index);
  };

  // 鼠标离开恢复自动切换
  const handleMouseLeave = () => {
    autoSwitchRef.current = setInterval(() => {
      setActiveTab((prev) => (prev + 1) % tabs.length);
    }, 2000);
  };

  return (
    <section className="w-full h-auto">
      {/*欢迎*/}
      <div className="relative w-full h-full flex flex-col items-center px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] bg-left bg-no-repeat">
        {/*背景*/}
        <div className="absolute inset-0 -z-10 w-full h-full">
          <Image src="/welcome_bg_09.png" alt="聚焦AI作业管理背景" fill />
        </div>
        <div className="w-full max-w-[1360px] py-[90px] flex flex-col gap-[66px]">
          {/*欢迎体验文字*/}
          <div className="w-full flex flex-col gap-[20px]">
            <div className=" font-semibold text-[46px] [@media(min-width:415px)_and_(max-width:660px)]:text-[40px] [@media(max-width:414px)]:text-[clamp(2rem,9vw,2.5rem)] leading-[52px] tracking-[0px] text-center text-[#333333]">
              欢迎体验
            </div>
            <div className=" font-normal text-lg [@media(max-width:414px)]:text-[14px] leading-7 tracking-[2px] text-center text-[#666666]">
              作业批、学情析、家校联，让AI技术赋能教与学
            </div>
          </div>
          {/*内容*/}
          <div className="w-full h-full flex gap-[clamp(10px,5vw,56px)] flex-row [@media(max-width:1080px)]:flex-col">
            <div className="w-full flex flex-1 min-w-[200px] mx-auto flex-col gap-[24px]">
              {/*tab导航*/}
              <div className="w-full overflow-hidden">
                <div className="flex flex-row gap-[24px] [@media(max-width:660px)]:gap-[10px] overflow-x-auto [&::-webkit-scrollbar]:hidden">
                  {tabs.map((tab, index) => (
                    <div
                      key={tab.id}
                      className={`py-[14px] [@media(max-width:660px)]:py-[3px] px-[24px] [@media(max-width:660px)]:px-[10px] text-center rounded-[32px] whitespace-nowrap font-semibold text-[18px] [@media(max-width:1210px)]:text-[14px] leading-[34px] tracking-[0px] cursor-pointer ${
                        activeTab === index
                          ? "bg-[#1DBA55] text-white"
                          : "bg-[#FFFFFF] text-black"
                      }`}
                      onMouseEnter={() => handleMouseEnter(index)}
                      onMouseLeave={handleMouseLeave}
                      onClick={() => {
                        window.Log.action("experience_button_click", {
                          button: `${tab.name}`,
                          user_access_port: deviceType,
                        });
                      }}
                    >
                      {tab.name}
                    </div>
                  ))}
                </div>
              </div>
              {/*图片*/}
              <div className="w-full flex flex-1 flex-row items-center justify-center mx-auto min-w-[250px] px-[80px] [@media(max-width:1024px)]:px-[clamp(30px,5vw,80px)] [@media(max-width:768px)]:px-[50px] bg-[#FFFFFF] rounded-[20px] [@media(min-width:769px)_and_(max-width:1080px)]:gap-[100px] [@media(max-width:768px)]:gap-[24px] gap-[24px]">
                <div className="min-w-[100px] flex flex-col gap-[15px] items-center justify-center">
                  <Image
                    src={"/" + `${tabs[activeTab].imageLeft}`}
                    alt="左侧二维码"
                    width={127}
                    height={127}
                    className="object-contain"
                  />
                  <div className="w-full font-normal text-[14px] leading-[20px] tracking-[0px] text-center text-[#999999] flex flex-row items-center justify-center h-[20px]">
                    <Image
                      src="/weixin 3.png"
                      alt="logo"
                      width={22}
                      height={20}
                      className="object-contain"
                    />
                    微信扫一扫
                  </div>
                </div>
                <div className="max-w-[240px] min-w-[120px]">
                  <Image
                    src={"/" + `${tabs[activeTab].imageRight}`}
                    alt="右侧详情展示"
                    width={244}
                    height={355}
                    className="object-contain"
                  />
                </div>
              </div>
            </div>
            {/*视频*/}
            <div
              className="w-full flex-1 flex items-center min-w-[200px] flex-shrink-[2] mx-auto cursor-pointer"
              onClick={() => setShowVideo(true)}
            >
              <Image
                src="/welcome_video_09.png"
                alt="蜜蜂家校视频介绍"
                width={650}
                height={440}
                className="object-contain w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
      {/*在线咨询*/}
      <div className="w-full flex flex-col items-center bg-[#1DBA55] px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px]">
        <div className="w-full max-w-[1360px] py-[60px] flex items-center flex-col gap-[24px]">
          <div className="w-full font-[PingFang-SC] font-semibold text-[24px] [@media(max-width:414px)]:text-[20px] leading-[52px] tracking-[0px] text-center text-[#FFFFFF]">
            使用蜜蜂家校一站式人工智能“教+学”，让作业管理更AI
          </div>
          <a
            href="https://mifengjiaoyu.feishu.cn/share/base/form/shrcnPtXd6gal9wBuRiBUpjLrKb?prefill_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=%E5%AE%98%E7%BD%91&hide_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=1"
            target="_blank"
            rel="noopener noreferrer"
            className="w-[140px] h-[56px] rounded-[30px] px-[24px] py-[14px] bg-[#FFFFFF] font-semibold text-[18px] leading-[28px] tracking-[0.06em] text-center text-[#1DBA55] hover:bg-[#FFFFFFCC]"
            onClick={() => {
              window.Log.action("experience_button_click", {
                button: "在线咨询",
                user_access_port: deviceType,
              });
            }}
          >
            在线咨询
          </a>
        </div>
      </div>
      {/*更多信息*/}
      <div className="block [@media(max-width:1080px)]:hidden">
        <Bottom />
      </div>
      <div className="hidden [@media(max-width:1080px)]:block">
        <BottomH5 />
      </div>
      <Modal show={showVideo} type="1" onClose={() => setShowVideo(false)} />
    </section>
  );
};

export default Footer;
